import { createTableHookContexts } from "@tanstack/react-table";
import type { AppTableFeatures } from "./app-table-features";

/**
 * Scoped table/cell/header contexts for {@link createTableHook}.
 * Cell/header UI modules import these (not `use-app-table`) so the factory
 * dependency graph stays acyclic for Vite HMR.
 *
 * @see https://github.com/TanStack/table/issues/6348
 */
export const {
	tableContext: appTableContext,
	cellContext: appCellContext,
	headerContext: appHeaderContext,
	useCellContext: useAppCellContextBase,
	useHeaderContext: useAppHeaderContextBase,
	useTableContext: useAppTableContextBase,
} = createTableHookContexts<AppTableFeatures>();
